export default __webpack_public_path__ + "static/media/login_bg.6bfe7e0c.jpg";